// extracted by mini-css-extract-plugin
module.exports = {"button":"quantity_button__N3CoO","input":"quantity_input__OSMW_"};